package space.stanton.generated

data class BlogPostInfo(
  val title: String = "untitled",
  val date: String,
  val route: String,
  val excerpt: String = "",
  val tags: List<String> = emptyList(),
)